import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { Title, UpgradePlanModal } from '@/components/UI';
import styles from './ConvertTemplateUpgrade.module.scss';
import { withStyles } from 'vopay';

// Import SVGs
import accountBalanceIcon from './icons/accountBalance.svg';
import currencyExchangeIcon from './icons/currencyExchange.svg';
import listIcon from './icons/list.svg';
import taskIcon from './icons/task.svg';

const cn = withStyles(styles);

type ConvertTemplateUpgradeProps = {
  isVisible: boolean;
  onCloseModal: () => void;
};

type FC = FunctionComponent<ConvertTemplateUpgradeProps>;

const ConvertTemplateUpgrade: FC = ({ isVisible, onCloseModal }) => {
  const { t } = useTranslation('translations', { keyPrefix: 'FileUpload.FileUploadDrawer.ConvertTemplateUpgrade' });

  return (
    <UpgradePlanModal
      isVisible={isVisible}
      title={t('title')}
      description={t('description')}
      ticketSubject={t('subject')}
      onCloseModal={onCloseModal}
    >
      <div className={cn('convertTemplateUpgrade')}>
        <div className={cn('convertTemplateUpgradeItem')}>
          <img src={listIcon} alt="List" className={cn('item')} />
          <div className={cn('content')}>
            <Title level="6">Convert to any bank format</Title>
            <div className={cn('description')}>Turn your template into bank accepted format</div>
          </div>
        </div>
        <div className={cn('convertTemplateUpgradeItem')}>
          <img src={accountBalanceIcon} alt="Account Balance" className={cn('item')} />
          <div className={cn('content')}>
            <Title level="6">Fallback Payment Rail</Title>
            <div className={cn('description')}>Ensures payments still process if the primary rail fails</div>
          </div>
        </div>
        <div className={cn('convertTemplateUpgradeItem')}>
          <img src={currencyExchangeIcon} alt="Currency Exchange" className={cn('item')} />
          <div className={cn('content')}>
            <Title level="6">Currency & Rail Flexiblity</Title>
            <div className={cn('description')}>Supports multiple payment rails</div>
          </div>
        </div>

        <div className={cn('convertTemplateUpgradeItem')}>
          <img src={taskIcon} alt="Task" className={cn('item')} />
          <div className={cn('content')}>
            <Title level="6">Error Reduction</Title>
            <div className={cn('description')}>Eliminates manual reformatting mistakes</div>
          </div>
        </div>
      </div>
    </UpgradePlanModal>
  );
};

export default ConvertTemplateUpgrade;
